import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Card } from 'antd'
const { WizSpin, WizTooltip } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import './index.less'

import CounselingHeader from './header'
import OnlineNotification from './onlineNotification/index'
import AntecedentIntervention from './antecedentIntervention/index'
import PreAuditProcess from './preAudit/index'
import Coach from './coach/index'
import Track from './track/index'
import Review from './review/index'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/counselingProcess') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('counselingProcess', record)
        } else {
            record = Session.get('counselingProcess') || {}
        }
    }
    return record
}

class CounselingProcess extends WizContainer {

    componentName = 'CounselingProcess'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        let { flowStates, status } = record
        let process = flowStates && flowStates.length ? flowStates[0] || 6 : 1
        this.state = {
            process,
            record,
            remind: [],
            processInfo: {
                onlineNotification: {
                    state: flowStates.includes(1) ? 2 : 1,
                    contentList: []
                },
                antecedentIntervention: {
                    state: flowStates.includes(2) ? 2 : 1,
                    contentList: []
                },
                preAuditProcess: {
                    state: process > 3 ? 1 : process === 3 ? 2 : 0,
                    contentList: []
                },
                coach: {
                    state: process > 4 ? 1 : process === 4 ? 2 : 0,
                    contentList: []
                },
                track: {
                    state: process > 5 ? 1 : process === 5 ? 2 : 0,
                    contentList: []
                },
                review: {
                    state: status === 1 ? 1 : process === 6 ? 2 : 0,
                    contentList: []
                }
            }
        }
    }

    _componentDidMount() {
        this._currentProcess()
    }

    _currentProcess = () => {
        const { record = {} } = this.state
        this.doActions([{
            path: 'integrationCounseling/detail',
            payload: {
                key: 'detail@' + record.id,
                apiParams: {
                    id: record.id
                }
            }
        }, {
            path: 'integrationCounseling/processRemind',
            payload: {
                key: 'processRemind@' + record.id,
                apiParams: {
                    id: record.id
                }
            }
        }, {
            path: 'integrationCounseling/processList',
            payload: {
                key: 'processList@' + record.id,
                apiParams: {
                    fuseTutorId: record.id
                }
            }
        }])
    }

    propsAndStateOnChange = {
        detail: this._detailOnChange.bind(this),
        processRemind: this._processRemindOnChange.bind(this),
        processList: this._processListOnChange.bind(this)
    }

    _detailOnChange(nextProps, nextState) {
        if (nextProps.detail && nextProps.detail.code === 1) {
            let record = { ...nextState.record, ...nextProps.detail.data }
            let { flowStates } = record
            let process = flowStates && flowStates.length ? flowStates[0] || 6 : 1
            nextState.record = record
            nextState.process = process
        } else {
            wizNotice.error(nextProps.detail.msg)
        }
        return true
    }

    _processRemindOnChange(nextProps, nextState) {
        if (nextProps.processRemind && nextProps.processRemind.code === 1) {
            nextState.remind = nextProps.processRemind.data
        } else {
            wizNotice.error(nextProps.processRemind.msg)
        }
        return true
    }

    _processListOnChange(nextProps, nextState) {
        if (nextProps.processList && nextProps.processList.code === 1) {
            let { data } = nextProps.processList
            let { processInfo } = this.state
            if (data && data.length) {
                data.forEach(item => {
                    let { type } = item
                    switch (type) {
                        case 1:
                            processInfo.onlineNotification = item
                            break
                        case 2:
                            processInfo.antecedentIntervention = item
                            break
                        case 3:
                            processInfo.preAuditProcess = item
                            break
                        case 4:
                            processInfo.coach = item
                            break
                        case 5:
                            processInfo.track = item
                            break
                        case 6:
                            processInfo.review = item
                            break
                    }
                })
                nextState.processInfo = processInfo
            }
        } else {
            wizNotice.error(nextProps.processList.msg)
        }
        return true
    }

    _onProcess = (disabled, index) => {
        if (!disabled) {
            this.setState({ process: index })
        } else {
            wizNotice.warn('流程暂未开始')
        }
    }

    _renderProcessItem = (title, index) => {
        let { process, processInfo } = this.state
        let className = index === process ? 'process-item process-item-active' : 'process-item'
        let state
        switch (index) {
            case 1:
                state = processInfo.onlineNotification.state
                break
            case 2:
                state = processInfo.antecedentIntervention.state
                break
            case 3:
                state = processInfo.preAuditProcess.state
                break
            case 4:
                state = processInfo.coach.state
                break
            case 5:
                state = processInfo.track.state
                break
            case 6:
                state = processInfo.review.state
                break
        }
        let img = null
        let disabled = false
        if (state === 1) {
            img = index === this.state.process
                ? <img className='process-icon' src={constants.files.sys_counseling_proess_active} />
                : <img className='process-icon' src={constants.files.sys_counseling_process_active_white} />
        } else if (state === 2) {
            img = index === this.state.process
                ? <img className='process-icon' src={constants.files.sys_counseling_in_progress} />
                : <img className='process-icon' src={constants.files.sys_counseling_in_progress_white} />
        } else {
            disabled = true
        }
        return (
            <div key={'process_' + index} className={className} onClick={() => this._onProcess(disabled, index)}>
                {img}
                <span>{title}</span>
            </div>
        )
    }

    _renderProcessBar = () => {
        let processes = [
            '上线通知',
            '前期介入',
            '预审核',
            '辅导',
            '跟踪',
            '检核'
        ]
        return (
            <div className='counseling-process-row'>
                {processes.map((process, index) => this._renderProcessItem(process, index + 1))}
                {this._renderRemind()}
            </div>
        )
    }

    _renderRemind = () => {
        let { remind } = this.state
        if (remind && remind.length) {
            let title = []
            remind.forEach(item => {
                title.push(<div>{item}</div>)
            })
            return (
                <div className='process-tips'>
                    <WizTooltip placement='left' title={title} overlayStyle={{ maxWidth: 500 }}>
                        <img src={constants.files.sys_counseling_tips} />
                    </WizTooltip>
                </div>
            )
        } else {
            return null
        }
    }

    _renderContent = () => {
        let { process, record, processInfo } = this.state
        let props = {
            record,
            jumpPage: this.jumpPage
        }
        switch (process) {
            case 1:
                return <OnlineNotification {...props} process={processInfo.onlineNotification} />
            case 2:
                return <AntecedentIntervention {...props} process={processInfo.antecedentIntervention} />
            case 3:
                return <PreAuditProcess {...props} process={processInfo.preAuditProcess} />
            case 4:
                return <Coach {...props} process={processInfo.coach} />
            case 5:
                let coachTime = processInfo.coach && processInfo.coach.contentList.length && processInfo.coach.contentList[0].completeTime
                return <Track {...props} process={processInfo.track} coachTime={coachTime} />
            case 6:
                return <Review {...props} process={processInfo.review} />
            default:
                return null
        }
    }

    render() {
        let { record } = this.state
        let { integrationCounselingLoading } = this.props
        return (
            <WizSpin spinning={integrationCounselingLoading} >
                <CounselingHeader record={record} />
                <Card className='antui-card counseling-process' title={this._renderProcessBar()}>
                    {this._renderContent()}
                </Card>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { integrationCounseling } = state
    const { id } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(integrationCounseling, 'detail@' + id)
    const processRemind = modelUtils.getModelEntity(integrationCounseling, 'processRemind@' + id)
    const processList = modelUtils.getModelEntity(integrationCounseling, 'processList@' + id)
    const loading = modelUtils.getLoadingState(state, 'integrationCounseling')
    return {
        detail,
        processRemind,
        processList,
        ...loading
    }
}

export default connect(mapStateToProps)(CounselingProcess)


